module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "pro",
      "epub:type": "prologue",
      "role": "doc-prologue"
    }
  }, [_c('header', [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('h1', {
    staticClass: "Chap-Title-ct"
  }, [_c('span', {
    attrs: {
      "aria-label": "1",
      "id": "pg_1",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pro",
      "id": "pro",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PROLOGUE")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Epigraph-non-verse-cepi"
  }, [_vm._v("“Certainty of death. Small chance of success. What are we waiting for?”")]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Epigraph-Source-ceps"
  }, [_vm._v("GIMLI, "), _c('i', [_vm._v("THE LORD OF THE RINGS: RETURN OF THE KING")])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Ornament-corn"
  }, [_c('span', {
    staticClass: "cotx"
  }, [_vm._v("ASH HAD ONLY")]), _vm._v(" just dropped his sword, surveying the remains of the battle, when the elf at his side spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Look there,” Valeria panted. “The Dark Lord has sent another wave.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Another?!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She pointed with the tip of her sword. “From the north.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ash turned. One final squadron of orcs poured over the hills in a wave of inarticulate screams and blood-splashed armor. He took position. “I’ll just have to stop them, then.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“The other fighters are heading to the gates,” she said. “We should go.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You’ll die here, Ash.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“The orcs can "), _c('i', [_vm._v("try")]), _vm._v(" to kill me.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "2",
      "id": "pg_2",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“They’ll succeed. Even the old gods couldn’t hold back so many.” She laughed grimly. “Nor the new.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He glanced over at her—auburn haired and defiant—and he forced a hard smile. “Then I’ll die, but you don’t need to. Go on, then, Vale. Follow the others.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Mmm…” She wiped the bloody sword on the side of her pant leg. “I think I’ll stay.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The orcs grew closer, the dark smudge growing.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He felt, more than saw, the elf take her place at his side. Ash knew there was no way two fighters—even good ones—could stop an onslaught like this. The elf was young. Inexperienced. It pained him that she’d die here.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("His fingers rolled over the sword’s hilt. “We need to stop them before they reach the gate. They’ll take the castle otherwise.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Valeria nodded. “There are twelve,” she said. “But none on chargers. That’s a bit of luck.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Mmph. Not enough luck.” Ash lifted his battered shield, sword arm shaking. He widened his stance. Though he was a born fighter, he was tired. Today’s campaign had sapped him. Foot by foot, the orcs clamored and wailed, broadswords lifted as they surged up the hill. Twelve against two. An impossible number.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Ready … ready…,” Ash muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Orcs, like ogres, were by nature impulsive, and most of them came straight toward the two fighters. But partway up the hill, four fanned out. "), _c('i', [_vm._v("They’ll head around the side")]), _vm._v(", he thought. "), _c('i', [_vm._v("Flank us as we fight.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ash’s gaze flicked to the elf at his side, and his heart twisted. She "), _c('span', {
    attrs: {
      "aria-label": "3",
      "id": "pg_3",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("was here because of him. “I really think you ought to go,” he said. “I can hold them off.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Liar.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Fine. I could hold them till you reached the gate.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She laughed. “It wouldn’t be long enough. You’d still die. And so would I. And they would reach the gate … and the others. And the campaign would end.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The first orcs were nearly to the top now. Ash could see their blackened teeth and yellow eyes. He could almost smell the dung clinging to the riders’ boots, the blood that soiled their tunics.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Then we stay and die,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She nodded. “Together.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ash’s pulse surged as adrenaline took hold. The first orc reached them, and he slammed his sword through its chest, jerking it out a split second later. The elf at his side attacked the second. He gritted his teeth and readied for the third.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('i', [_vm._v("And so the end begins …")])]), _vm._v(" "), _c('hr', {
    staticClass: "transition"
  }), _vm._v(" "), _c('p', {
    staticClass: "SB1"
  }, [_vm._v("Ash looked away from the faces on the computer’s screen and grinned. Far away in California, the Dungeon Master, Brian, continued to talk the remainder of the group through their campaign. With Ash and Vale dead (at least until someone could retrieve their bodies and use a spell to revive them), they were free to take a break.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ash flicked his long black hair out of his eyes. “That was fricking awesome!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "4",
      "id": "pg_4",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“It’d be "), _c('i', [_vm._v("more")]), _vm._v(" awesome if they hadn’t destroyed us,” Vale said with a tired laugh. “But you were right. That "), _c('i', [_vm._v("was")]), _vm._v(" pretty fun.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“See? I "), _c('i', [_vm._v("knew")]), _vm._v(" you’d like D&D!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Well … I think I’d like it more if I didn’t die on my first adventure.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Pfft! That’s part of the learning curve. You’ve gotta level up somehow, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She laughed and tossed the borrowed twenty-sided die onto the couch cushion. “Guess so.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Besides, we held them back long enough to save the rest of the team.” Ash pointed to the computer screen where four separate players talked through the battle. “Marco and Jutta are still going. And Rhys here? He’s got the gate closed. They’re moving away to—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You almost sound like you’re "), _c('i', [_vm._v("glad")]), _vm._v(" that we died.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Not glad, no.” A tangle of hair fell back into his eyes, and he tucked it behind one ear. “But happy it turned out.” Grinning, he glanced back to the videoconference where his teammates across the world braved onward, Vale and Ash’s sacrifices giving them the opportunity to carry on the larger campaign. Brian’s voice boomed forward: “"), _c('i', [_vm._v("With the gate closed, the orcs are finally repelled…”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“We did what we had to do,” Ash said.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("When Vale didn’t answer, he turned back around. She had her coat on and was unplugging her phone from the charger.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Wait. You "), _c('i', [_vm._v("can’t")]), _vm._v(" be going home already!” he said. “I want you to get to know the rest of the group.” Ash knew if he could just get Vale to stick through another couple of hours, he could persuade her to start gaming again—a goal he’d had forever. “Come on, Vale. The campaign just started!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "5",
      "id": "pg_5",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Started?” She giggled. “We’ve been playing for hours.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yeah, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’ve got to go, Ash.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Just another hour. One more.” He nodded to the basement. Vale had seemed "), _c('i', [_vm._v("happy")]), _vm._v(" when they’d been playing together. (Happier than he’d seen her in ages.) And though they hadn’t gamed together since middle school, he "), _c('i', [_vm._v("knew")]), _vm._v(" that she’d love it once she started again. Ash waggled his eyebrows. “I bet Rhys is already making a plan to revive us.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Ash…”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You watch, we’ll be back in no time.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Sorry, I would, but I really can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Because it’s like…” She glanced at her phone. “Ten thirty.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Exactly. Ten thirty. And you’re sixteen, not eight.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She stuck out her tongue. “But it’s Wednesday night.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“So what?” Ash stood from the couch. Side by side, the two friends were almost comically mismatched. Ash’s head brushed the basement’s low ceiling; Vale barely reached his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“We have to be at the school "), _c('i', [_vm._v("extra")]), _vm._v(" early tomorrow. The bus leaves at eight; we need to be there at seven thirty.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ash stared at her, confused.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“The trip to the mountains,” she said. “Remember…?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ash grimaced. “Ugh … right. The hiking trip.” He’d forgotten, but now that Vale had brought it back up, he felt a weight settle on his shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I’ve got to finish organizing my backpack.” Vale headed for the basement stairs. “You ready to go?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "6",
      "id": "pg_6",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Um…”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Vale shook her head. “Ash, have you even "), _c('i', [_vm._v("started")]), _vm._v(" packing yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He grinned. “Uh … kind of…?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Good. Because tomorrow’s not a joke.” She reached the top of the stairs and headed to the front door. Ash followed, waiting as she toed on her running shoes. “Two days in the mountains is going to be tough.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“It shouldn’t be that bad, should it?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Well…”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“C’mon, Vale. You hike all the time. You seem to like it well enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Vale zipped her jacket before she looked up. She wasn’t smiling anymore. “Hiking and outback camping are "), _c('i', [_vm._v("not")]), _vm._v(" the same thing,” she said, then pulled open the front door. “Holland’s arranging meals for us, but make sure you pack enough snacks for yourself, okay? It’s going to be a long couple days.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He grinned. “Snacks. Got it.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Good.” She stepped out into the night and smiled. Behind her the streetlights twinkled, the early autumn air just starting to cool. “And don’t forget to pack extra clothes. It’s going to be cold, especially at night. Bring a hat.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Uh-huh. Will do.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You’ll need some first aid stuff too. Band-Aids and all that.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Got it.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“We meet at the school at seven thir—”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I know, Mom. I know.” He laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“See you then. And don’t forget what I said about supplies.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Supplies. Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    attrs: {
      "aria-label": "7",
      "id": "pg_7",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("She jogged down the steps, pausing one last second. “Ash … you’re not going to ditch on me, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He rolled his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Aaaash…” she groaned, drawing his name out to twice its length.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“You "), _c('i', [_vm._v("like")]), _vm._v(" hiking, Vale. I’m hardly the mountaineering type.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Don’t you "), _c('i', [_vm._v("dare")]), _vm._v(".” She pointed at him. “I will "), _c('i', [_vm._v("kill")]), _vm._v(" you if you skip out tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He laughed louder.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Seriously,” Vale said. “I’ll literally walk to your house and wake you up if you’re not waiting for the bus at seven thirty.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yeah, and that doesn’t sound crazy at all.” He snorted.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I played your game with you, didn’t I?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ash smiled. “Yeah, you did.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“And I died "), _c('i', [_vm._v("terribly")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“So?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“So you owe me one.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He laughed. “Are you fricking "), _c('i', [_vm._v("blackmailing")]), _vm._v(" me to do this dumb hike with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Vale let out an angry huff. “Seriously, Ash, just … just be there.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Will you promise to be part of another campaign if I say yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She shot him a dirty look.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Kidding!” he laughed. “I’ll be there. Relax.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Good.” Vale sighed and shook her head. “G’night, Ash.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“’Night, Vale. Text when you make it home.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Got it.” She waved once and headed down the street.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ash watched until she reached the corner before he pulled the door closed. He frowned. Ash "), _c('i', [_vm._v("hated")]), _vm._v(" the outdoors. He had no idea what food "), _c('span', {
    attrs: {
      "aria-label": "8",
      "id": "pg_8",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("to bring along, never mind first aid supplies. And if they were supposed to "), _c('i', [_vm._v("sleep")]), _vm._v(" outside, then shouldn’t he bring a pillow? Or a sleeping bag? Wasn’t there a letter that went through all that? He sighed, weighing the idea of skipping out. Guilt nipped at him the moment it crossed his mind. Vale "), _c('i', [_vm._v("had")]), _vm._v(" come over and played Dungeons & Dragons tonight … the first game she’d played in years. That meant something. He grinned. "), _c('i', [_vm._v("Now if I can only persuade her to get back into video games too, we’ll be—")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("A triumphant shout from several of the other players echoed forward.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Hearing it, Ash turned in surprise. “What the…?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Rhys’s voice echoed up from the basement. “"), _c('i', [_vm._v("Awesome!")]), _vm._v("” he said. “"), _c('i', [_vm._v("I cast a regeneration spell. Are Ash and Vale still around?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Hold up! I’m still here!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ash sprinted back down the basement stairs, ready to rejoin the ongoing battle, Vale’s good advice already forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("His team needed him!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018286a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 72
// module chunks = 0